import React from 'react'
import clsx from 'clsx'
import CustomToolTip from '@Components/Tooltips/CustomToolTip'
import { RightsholderClaimedShare } from '@App/entities/rightsholder'
import { WriterModel } from '@Entities/work/writer-model'
import { formatName } from '@App/helpers/format-name'

interface WorkItemSharesInfoProps {
    writers: WriterModel[]
    claimedShare?: RightsholderClaimedShare
    claimType?: boolean
    totalKnownShares: number
    publicSearchType?: boolean
    catalogType?: boolean
    historyType?: boolean
}

const WorkItemSharesInfo = ({
    writers,
    claimedShare,
    claimType,
    totalKnownShares,
    publicSearchType,
    catalogType,
    historyType,
}: WorkItemSharesInfoProps) => (
    <>
        {writers && writers.length && (
            <div className="writers-sub-info">
                <p className="small-2">
                    <span>
                        {writers.map((obj) => obj && formatName(obj.firstName, obj.lastName, obj.fullName)).join(', ')}
                    </span>
                </p>
            </div>
        )}
        {claimedShare && claimType && (
            <p className="small-2 claimed-shares-sub-info">
                <span className="total-claimed-shares">Your Claimed Share:&nbsp;</span>
                <span className="bold total-claimed-shares claim-number">{claimedShare.rightsholderClaimedShare}%</span>
            </p>
        )}
        {totalKnownShares ? (
            <p className="small-2 shares-sub-info">
                {claimType ? (
                    <span>
                        <span className="total-claimed-shares">Total Claimed Shares:&nbsp;</span>
                    </span>
                ) : (
                    <span>{historyType ? 'Total Submitted Shares:' : 'Total Known Shares:'}&nbsp;</span>
                )}
                <span className="percent-with-tooltip">
                    {publicSearchType || catalogType ? (
                        <>
                            {totalKnownShares < 100 ? (
                                <span className="line">
                                    <span className="bold">{totalKnownShares}%&nbsp;</span>
                                    <CustomToolTip
                                        type="?"
                                        info="Part of these shares are unknown, so total is less than 100%"
                                    />
                                </span>
                            ) : (
                                <span className="bold">{totalKnownShares}%</span>
                            )}
                        </>
                    ) : (
                        <>
                            <span className={clsx('bold', claimType && 'total-claimed-shares claim-number')}>
                                {totalKnownShares}%
                            </span>
                            {historyType && (
                                <CustomToolTip
                                    type="?"
                                    info={
                                        'Registration History is a display your work submissions "as received" by The MLC and therefore the' +
                                        ' information, including Total Submitted Shares, is subject to change pending the completion of' +
                                        ' processing. Upon successful validation and ingestion of the registration, the work will be' +
                                        ' available in the Catalog section and represent the fully processed details.'
                                    }
                                />
                            )}
                        </>
                    )}
                </span>
            </p>
        ) : (
            <p className={clsx('small-2', claimType && 'total-claimed-shares')}>
                <>
                    {claimType ? (
                        <span className="total-claimed-shares">Total Claimed Shares:&nbsp;</span>
                    ) : (
                        <span>{historyType ? 'Total Submitted Shares:' : 'Total known shares:'}&nbsp;</span>
                    )}
                    <span className={clsx('bold', claimType && 'total-claimed-shares claim-number')}>0%</span>
                </>
            </p>
        )}
    </>
)

export default WorkItemSharesInfo
